import React from "react";
import { Button, Col, Container, Row } from "react-bootstrap";

interface PricingPlans {
  name: string;
  icon: string;
  features: string[];
  price: string;
  ribbon: boolean;
  style?: string;
  href?: string;
}

const pricingPlans: PricingPlans[] = [
  {
    name: "Basic Website",
    icon: "pe-7s-graph1",
    features: [
      "1–3 Pages Website",
      "Responsive Design",
      "Basic Contact Form",
      "Fast Delivery",
      "Basic Support Included",
    ],
    price: "$199.99",
    href:
      "https://wa.me/923134561816?text=Hi%20Abdul%20Rehman,%20I'm%20interested%20in%20the%20Basic%20Website%20Package%20(1%E2%80%933%20pages).%20Can%20you%20share%20more%20details?",
    ribbon: false,
  },
  {
    name: "Professional Website",
    icon: "pe-7s-gleam",
    features: [
      "5–10 Pages Website",
      "Modern UI/UX + Animations",
      "Admin Panel / Dashboard (Optional)",
      "API Integration",
      "Priority Support",
    ],
    price: "$549.99",
    href:
      "https://wa.me/923134561816?text=Hi%20Abdul%20Rehman,%20I'm%20interested%20in%20the%20Professional%20Website%20Package%20(5%E2%80%9310%20pages%20with%20UI/UX).%20Can%20we%20discuss%20features%20and%20pricing?",
    style: "business-pricing-box-active",
    ribbon: true,
  },
  {
    name: "Business System / Web App",
    icon: "pe-7s-way",
    features: [
      "Custom Dashboard / CRM",
      "User Roles & Authentication",
      "Advanced Database Structure",
      "API Development",
      "Full Support & Maintenance",
    ],
    price: "$999.99",
    href:
      "https://wa.me/923134561816?text=Hi%20Abdul%20Rehman,%20I'm%20interested%20in%20a%20Business%20System%20%2F%20Web%20App.%20I%20want%20to%20discuss%20my%20requirements%20for%20a%20custom%20dashboard%20or%20CRM.",
    ribbon: false,
  },
];

const Pricing: React.FC = () => {
  return (
    <React.Fragment>
      <section className="section business-pricing" id="pricing">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              <div className="text-center">
                <h2 className="heading-title-title letter-spacing_4 text-uppercase">
                  Pricing Plan
                </h2>
                <p className="heading-title-desc text-muted mt-4">
                  Transparent and simple pricing for websites, mobile apps, and
                  custom business systems. Choose the plan that fits your
                  project — or contact us for a custom quote.
                </p>
              </div>
            </Col>
          </Row>

          <Row className="mt-5 pt-3">
            {(pricingPlans || [])?.map((item: PricingPlans, index: number) => (
              <Col lg={4} key={index}>
                <div
                  className={`business-pricing-box ${item.style} text-center mt-4`}
                >
                  <div className="p-4 mt-3">
                    {item.ribbon && (
                      <div className="business-pricing-lable">
                        <span className="business-lable-name">POPULAR</span>
                      </div>
                    )}

                    <div className="business-pricing-icon">
                      <i className={item.icon}></i>
                    </div>
                    <h4 className="business-pricing-title text-uppercase letter-spacing_4 mt-4">
                      {item.name}
                    </h4>
                  </div>
                  <div className="business-pricing-features">
                    {(item.features || [])?.map((feature, index) => (
                      <p className="text-muted mb-0" key={index}>
                        {feature}
                      </p>
                    ))}
                  </div>
                  <div className="p-4">
                    <div>
                      <h1>{item.price}</h1>
                    </div>
                    <div className="p-4">
                      <Button
                        href={item.href}
                        target="_blank"
                        className="btn btn-md btn-dark-custom"
                      >
                        Purchase now
                      </Button>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Pricing;
